import { useMemo } from 'react'
import { ValueFormatterParams } from 'ag-grid-community'
import { dateFormatter } from '../../../utils/dateFormatter'
import { numberFormatter } from '../../../utils/numberFormatter'

const amountFormatter = (params: ValueFormatterParams) => {
  if (params.value == null || params.value === '') return ''
  const value = Number(params.value)
  if (!isFinite(value)) return ''
  return value
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

export const useAccountSpecColDefs = (isOmbyggnad: boolean) => {
  const accountSpecColDefs = useMemo(
    () => [
      {
        field: 'grandParentAccountName',
        rowGroup: true,
        hide: true,
      },
      {
        field: 'parentAccountName',
        rowGroup: true,
        hide: true,
      },
      {
        field: 'amount',
        headerName: 'Belopp',
        aggFunc: 'sum',
        type: 'numericColumn',
        valueFormatter: isOmbyggnad ? amountFormatter : numberFormatter,
      },
      {
        headerName: 'Bokf. Dat.',
        field: 'postingDate',
        type: ['rightAligned', 'date'],
        valueFormatter: dateFormatter,
      },
      {
        headerName: 'Period',
        field: 'period',
        type: 'rightAligned',
      },
      {
        headerName: 'Beskrivning',
        field: 'description',
        flex: 2,
        type: 'rightAligned',
      },
      {
        headerName: 'Ver.Id',
        field: 'verificationId',
        type: 'numericColumn',
      },
    ],
    [isOmbyggnad]
  )

  return accountSpecColDefs
}
